// this is here for webpack to expose SwupTheme as window.SwupTheme
import SwupTheme from './src/index.js';
export default SwupTheme;
